export enum InterventionOperationsTypes {
  MECHANICAL_WEEDING = 'mechanical weeding',
  OTHER_OPERATION = 'other operation',
  FOREIGN_MATERIAL = 'foreign material',
}
